import React, { useState, forwardRef, useMemo, useCallback } from 'react';
import { find, uniqBy } from 'lodash';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import GenericMappingForm from '../GenericMappingForm';
import { FieldTypes } from 'utils/formUtils';
import { Form } from 'antd';
import _ from 'lodash';

const CoverityMappingForm = forwardRef(({disableProjectFields = false, ...props}, ref) => {
  const [form] = Form.useForm();
  const [options, setOptions] = useState(() => {
    if (props.record) {
      const { projectId, projectName, streamName } = props.record;
      return [{id: projectId, name: projectName, otherProperties: { ...(streamName && {streamNames: [streamName]}) }}]
    }
    return [];
  });
  
  const setOptionsFromPagination = (option) => {
    setOptions(prev => uniqBy([...option, ...prev,], 'name'));
  }

  const fetchRepos = useCallback((params) => {
    let { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { ...params, login_id: props.loginConfigId });
    promise.then((data) => setOptionsFromPagination(data.projects))
    promise = promise.then(response => response.projects);
    return { promise,cancel}
  }, [props.toolName, props.loginConfigId]);

  const getExtraFieldsData = (config) => {
    const { projectId, streamName } = config;
    const projectName = find(options, (obj) => obj.id === projectId)?.name;
    return ({
      projectId,
      projectName,
      streamName
    });
  }

  const projectChangeHandler = useCallback((value, field) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    configurations[name] = {
      ...configurations[name],
      streamName: undefined,
    }
    form.setFieldsValue({ configurations: configurations });
  }, [form])

  const isProjectFieldDisabled = useCallback((fieldKey, form) => {
    const fieldConfiguration = form.getFieldValue("configurations")[fieldKey];
    return (!fieldConfiguration || !fieldConfiguration.projectId || disableProjectFields);
}, [disableProjectFields]);

  const extraFields = useMemo(() => ([
    {
      name: 'projectId',
      colSpan: '12',
      type: FieldTypes.SELECT, 
      label: 'Coverity Project',
      disabled: disableProjectFields,
      rules: [{ required: true, message: `Coverity Project is required` }],
      props: {
        api: fetchRepos,
        autoFocus: !disableProjectFields,
        allowClear: true,
        onChange: projectChangeHandler,
      }
    },
    {
      name: 'streamName',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Stream Name',
      propsGenerator: (fieldKey) => ({ disabled: isProjectFieldDisabled(fieldKey, form) }),
      props: {
        allowClear: true,
        setExtraProps: (field, listField) => {
            const allConfigs = form.getFieldsValue().configurations;
            const projectID = allConfigs[listField.name]?.projectId;
            const selectValue = _.find(options, { id: projectID });
            const streamOptions = selectValue?.otherProperties?.streamNames ? selectValue.otherProperties.streamNames : [];
            return {
                options: streamOptions,
                resetOptionsProp: projectID
            }
        }
    }
    }
  ]), [fetchRepos,projectChangeHandler, isProjectFieldDisabled, options, form, disableProjectFields,]);

  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default CoverityMappingForm;